var map = {
	"./pools-arbitrum.js": "07db",
	"./pools-aurora.js": "7ad2",
	"./pools-avalanche.js": "18e2",
	"./pools-bsc.js": "3c5e",
	"./pools-celo.js": "4f1f",
	"./pools-ethereum.js": "0224",
	"./pools-fantom.js": "e0c1",
	"./pools-harmony.js": "46e8",
	"./pools-kava.js": "1baf",
	"./pools-moonbeam.js": "4125",
	"./pools-optimism.js": "fd4f",
	"./pools-polygon.js": "4e1d",
	"./pools-xdai.js": "02aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4974";